import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import IToken from 'interfaces/IToken';
import ITokens from 'interfaces/ITokens';

export async function callApi(refreshToken: IToken): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/User/RefreshToken`;
	return axios.post(url, { token: refreshToken.token }).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = ITokens;
